import React from 'react';
import { graphql } from 'gatsby';
import ToolboxLayout from 'layouts/toolboxLayout';
import {
  getFeaturedPost,
  getUpcomingPosts,
  removeFeatureAndSubscribePosts,
  filterPostsFromSplashAndToolbox,
} from 'components/Page/Webinar/utils/postsUtils';
import { SectionLayout } from 'components/Sections/SectionLayout';
import ToolboxSplashHero from 'components/Page/Webinar/Hero';
import ToolboxSplashUpcoming from 'components/Page/Webinar/Upcoming';
import ToolboxSplashPostsContainer from 'components/Page/Webinar/PostsContainer';
import useIsClient from 'hooks/useIsClient';
import headsetIcon from 'images/headset-black.svg';
import getBreakpointView from 'utils/getBreakpointView';

const ToolboxSplash = props => {
  const seo = props?.data?.seo;
  const allWebinarPosts = props?.data?.allContentfulWebinar?.edges?.map(webinar => webinar.node);
  const placeholderImage = props?.data?.placeholderImage?.image?.fluid;
  const noResultsImage = props?.data?.allContentfulImage?.edges[0]?.node?.image?.fluid;
  const splashPagePosts = filterPostsFromSplashAndToolbox(allWebinarPosts);
  const splashPostsForDisplay = removeFeatureAndSubscribePosts(splashPagePosts);
  const upcomingPosts = getUpcomingPosts(splashPagePosts);
  const featuredPost = getFeaturedPost(splashPagePosts);
  const isClient = useIsClient();
  const isMobile = getBreakpointView(['xs']);

  const breadcrumbs = {
    data: [
      {
        title: 'Toolbox',
        icon: null,
        url: '/toolbox',
      },
      !isMobile && {
        title: 'Webinars',
        icon: headsetIcon,
        url: '',
      },
    ],
    absolute: true,
  };

  return (
    <ToolboxLayout breadcrumbs={breadcrumbs} contentfulSeo={seo} {...props}>
      <SectionLayout contentBelowSection>
        <ToolboxSplashHero featuredPost={featuredPost} placeholderImage={placeholderImage} />
      </SectionLayout>
      {upcomingPosts.length > 0 && isClient && (
        <SectionLayout contentBelowSection>
          <ToolboxSplashUpcoming upcomingPosts={upcomingPosts} />
        </SectionLayout>
      )}
      <SectionLayout>
        <ToolboxSplashPostsContainer
          posts={splashPostsForDisplay}
          placeholderImage={placeholderImage}
          noResultsImage={noResultsImage}
        />
      </SectionLayout>
    </ToolboxLayout>
  );
};

export const WebinarPageTemplatePageQuery = graphql`
  query WebinarToolboxSplashPageQuery {
    allContentfulWebinar {
      edges {
        node {
          ...Webinar
        }
      }
    }
    seo: contentfulSeo(internalName: { eq: "SEO - Webinar Splash Page" }) {
      ...Seo
    }
    placeholderImage: contentfulImage(contentful_id: { eq: "OTA5Cs6JPizmtTCcU0FtO" }) {
      ...WebsiteImage
    }
    contentfulFooter(contentful_id: { eq: "2B5mDNSOuDSO2Pr5QDlbg" }) {
      ...Footer
    }
  }
`;

export default ToolboxSplash;
